import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppShell from './AppShell';

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
